<template>
  <!-- /.panel-heading -->
  <div class="panel-body deposit-options">
    <div class="panel-heading panel-heading-color">{{$t('deposit.select_amount_to_deposit')}}</div>
    <div class="row">
      <div class="col-md-offset-3 col-md-6 col-lg-offset-3 col-lg-6 col-xl-offset-3 col-xl-6">
        <div class="panel panel-default panel-choose">
          <div class="row">
            <div class="col-xs-12 col-sm-8">
              <label>{{$t('deposit.amount')}}</label>
              <input
                type="text"
                v-model="options.amount"
                class="form-control"
                @focus="$event.target.select()"
              >
            </div>
            <div class="space-10 visible-xs"></div>
            <div class="col-xs-12 col-sm-4">
              <label>{{$t('deposit.currency')}}</label>
              <span class="data">{{options.pSPConfig.currency}}</span>
            </div>
          </div>
          <div class="space-30"></div>
          <div class="row deposit-funds">
            <div class="col-xs-4" v-for="v in options.amounts" v-on:click="setAmount(v)">
              <div :class="options.amount == v ?  'deposit selected' : 'deposit'">
                <label>{{v}}</label>
                <span>{{options.pSPConfig.currency}}</span>
              </div>
            </div>
          </div>
        </div>
        <!-- /.panel-body -->
      </div>
    </div>
    <div class="form-group row buttons-r">
      <div class="col-xs-12 col-md-offset-8 col-md-4">
        <button
          type="button"
          v-on:click="goToStep('payment')"
          class="btn btn-default mrg-b-25"
        >{{$t('shared.buttons.prev')}}</button>
        <button
          type="button"
          v-on:click="goToStep('summary')"
          :disabled="$v.options.amount.$invalid"
          class="btn btn-primary mrg-r-15 mrg-b-25 v-button"
        >{{$t('shared.buttons.next')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "@/event-bus";
import { required } from "vuelidate/lib/validators";
import siteConfiguration from '@/config';
const isDecimal = value => /^\d+(\.\d{1,2})?$/.test(value);
const isValidAmount = value => value > 0 && isDecimal;

export default {
  name: "GenericDepositOption",
  props: ["options", "amounts"],
  methods: {
    setAmount(amount) {
      this.$props.options.amount = amount;
    },
    goToStep(step) {
      EventBus.$emit("onGoToStep", step);
    }
  },
  validations: {
    options: {
      pSPConfig: {
        required
      },
      amount: {
        required,
        numberValid: isDecimal,
        isValidAmount
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/GenericDepositOption.vue